import React from 'react';

import {IconoirGroup} from '@ey-xd/motif-icon';

import {labels} from '../../../../../../util/utils';

import Button from '../../../../../CoreWrappers/Button';
import EngagementUsersDropdown from '../../../../EngagementUsersDropdown';

export const prop = '';

export const config = () => ({
	id: 'engagementUsersColumn',
	label: '',
	propName: prop,
	width: 'var(--px-80)',
	customCell: (item) => {
		const renderTrigger = () => {
			const props = {
				type: 'button',
				variant: 'ghost',
				size: 'medium',
				svg: IconoirGroup,
				iconSize: 20,
				title: labels.contactTeam
			};

			return <Button {...props} />;
		};

		const props = {
			engagementId: item.engId,
			renderTrigger
		};
		return <EngagementUsersDropdown {...props} />;
	}
});
